import React from "react"

export const FavoriteButton = (props) => {
  let {
    messageIfFavorited,
    messageIfNotFavorited,
    isMyFavorite,
    className,
    onClick,
    iconBeforeText = false,
  } = props

  const classNames = ["favorite-button-container", className]
    .filter(Boolean)
    .join(" ")
  return (
    <div
      onClick={() => {
        onClick()
      }}
      className={classNames}
      data-is-favorite={isMyFavorite}
      data-cy="favorite-button"
    >
      {iconBeforeText && <span className="glyphicon glyphicon-star" />}
      <span className="button-text">
        {isMyFavorite
          ? messageIfFavorited || "Added to Favorites"
          : messageIfNotFavorited || "Add to Favorites"}
      </span>
      {!iconBeforeText && <span className="glyphicon glyphicon-star" />}
    </div>
  )
}

FavoriteButton.defaultProps = {
  className: "btn-favorite-solid-default",
}
